module.exports = __webpack_public_path__ + "img/discover-landing.45ec9fa5.png";